/* Ovela Home — interactive behavior (announcement countdown, mobile nav toggle; isolated from ovela-pdp.js) */
(function () {
  'use strict';
  if (window.__ovelaHomeLoaded) return;
  window.__ovelaHomeLoaded = true;

  function formatCountdown(ms) {
    var s = Math.max(0, Math.floor(ms / 1000));
    var pad = function (n) { return String(n).padStart(2, '0'); };
    var h = Math.floor(s / 3600);
    var m = Math.floor(s / 60) % 60;
    var sec = s % 60;
    return pad(h) + ':' + pad(m) + ':' + pad(sec);
  }

  function initCountdown(root) {
    if (root.__ovelaCountdownInit) return;
    root.__ovelaCountdownInit = true;
    var els = root.querySelectorAll('[data-ovela-countdown]');
    if (!els.length) return;
    function tick() {
      els.forEach(function (el) {
        var endAttr = el.getAttribute('data-ovela-countdown-end');
        var end = endAttr ? new Date(endAttr) : null;
        if (!end || isNaN(end.getTime())) return;
        var diff = end - new Date();
        if (diff <= 0) {
          var dot = el.parentElement ? el.parentElement.querySelector('.ovela-announce__dot') : null;
          var label = el.parentElement ? el.parentElement.querySelector('.ovela-announce__label') : null;
          if (dot) dot.hidden = true;
          if (label) label.hidden = true;
          el.hidden = true;
          return;
        }
        el.textContent = formatCountdown(diff);
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  function initNavToggle(header) {
    if (header.__ovelaNavInit) return;
    header.__ovelaNavInit = true;
    var burger = header.querySelector('[data-ovela-nav-toggle]');
    var nav = header.querySelector('[data-ovela-nav]');
    if (!burger || !nav) return;

    function closeNav() {
      nav.classList.remove('is-open');
      burger.setAttribute('aria-expanded', 'false');
    }
    function openNav() {
      nav.classList.add('is-open');
      burger.setAttribute('aria-expanded', 'true');
    }

    burger.addEventListener('click', function () {
      if (nav.classList.contains('is-open')) {
        closeNav();
      } else {
        openNav();
      }
    });
    nav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', closeNav);
    });
    document.addEventListener('click', function (e) {
      if (!nav.classList.contains('is-open')) return;
      if (header.contains(e.target)) return;
      closeNav();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) {
        closeNav();
        burger.focus();
      }
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth >= 750) closeNav();
    });
  }

  function init() {
    document.querySelectorAll('[data-ovela-announce]').forEach(initCountdown);
    document.querySelectorAll('.ovela-header').forEach(initNavToggle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
